"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsModuleWrapper = void 0;
class FragmentsModuleWrapper {
    wrapModule(module, fragmentName) {
        if (module.bootstrap) {
            module.bootstrap = this.safeFunction(module.bootstrap, 'bootstrapping', fragmentName);
        }
        if (module.mount) {
            module.mount = this.safeFunction(module.mount, 'mounting', fragmentName);
        }
        if (module.unmount) {
            module.unmount = this.safeFunction(module.unmount, 'unmounting', fragmentName);
        }
        return module;
    }
    safeFunction(fn, processName, fragmentName) {
        return async (...args) => {
            try {
                return await fn(...args);
            }
            catch (error) {
                console.error(`[FragmentsLoader] Unhandled error while ${processName} "${fragmentName}":`, error);
                return Promise.resolve();
            }
        };
    }
}
exports.FragmentsModuleWrapper = FragmentsModuleWrapper;
